import React from 'react';
import Select from 'react-select-plus';
import Datetime from 'react-datetime';
import moment from 'moment-timezone';
import { Button } from 'modules/theme';
import { ControlLabel, FormControl } from 'modules/theme';
import { timezones } from './timezones';
import {
  FlexRow,
  FlexItem,
  InsightFilter,
  ItemSearch
} from './styles';
import { searchCompany } from 'modules/common/utils';
import { Alert } from 'modules/theme';
// import { InlineItems } from '../../settings/styles';
import Toggle from 'react-toggle';
import { FormWrapper, FormColumn, ModalFooter, Spinner } from 'modules/theme';
import { ModalTrigger, FormGroup } from 'modules/theme';
import { modalType } from './../../../helpers/dotenv';
import APIManager from 'modules/common/apiManager';
import SelectFilterAPI from '../../common/components/form/SelectFilterAPI'
import CommonManager from '../../../helpers/common';
var uuid = require('uuid');

const commonManager = new CommonManager()
class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    let zone = commonManager.getTimeZone();

    try {
      this.currentTimestamp =
        parseInt(
          moment()
            .endOf('day')
            .tz(zone.value)
            .format('X')
        ) * 1000;
      this.dayBeforeTimeStamp =
        parseInt(
          moment()
            .subtract(30, 'days')
            .tz(zone.value)
            .format('X')
        ) * 1000;
    }
    catch (err) {
      console.log('err', err)
    }
    this.state = {
      ...props.queryParams,
      // check condition for showing placeholder
      startDate: this.dayBeforeTimeStamp,
      endDate: this.currentTimestamp,
      // startDate: '',
      // endDate: '',
      isLoading: false,
      isChange: false,
      CampaignList: [],
      BreakList: [],
      StickyAgentList: [],
      UserList: [],
      projects: [],
      DesposeList: [],
      TeamList: [],
      selectedDespose: [],
      selectedTeam: [],
      selectedCampaign: [],
      selectedBreak: [],
      selectedStickyAgent: [],
      selectedUser: [],
      selectedFilter: null,
      formatDate: '',
      freeTextSearch: null,
      filterName: null,
      filterNameUpdate: null,
      _id: '',
      fromSelector: null,
      toSelector: null,
      GroupBy: null,
      isNew: true,
      toshowGroupby: 0,
      DatesBy: null,
      showStartEndDate: false,
      selectedColumns: [],
      timezone: zone,
      showHide: false,
      modalType: modalType
    };
    this.handleProjectSearch = this.handleProjectSearch.bind(this);
    this.handleBreakSearch = this.handleBreakSearch.bind(this);
    this.handleStickyAgentSearch = this.handleStickyAgentSearch.bind(this);
    this.handleUserSearch = this.handleUserSearch.bind(this);
    this.onClick = this.onClick.bind(this);
    this.resetAllData = this.resetAllData.bind(this);
    this.getBreak();
    this.getStickyAgent();
    this.getUser();
    this.getDespose();
    this.getTeam();
  }

  componentDidMount() {
    if (window.localStorage) {
    }
    else {
      this.setState({ toshowGroupby: 0 });
    }
    console.log(this.state.toshowGroupby);
  }

  componentWillReceiveProps(nextProps) {
    let result = nextProps.getSelectedColumnNames();
    this.setState({
      selectedColumns: result
    });
    this.setState({ isLoading: false })
    let zone = commonManager.getTimeZone();
    if (
      nextProps.selectedFilter &&
      typeof nextProps.selectedFilter.filterName !== 'undefined' &&
      (typeof this.props.selectedFilter === 'undefined' ||
        nextProps.selectedFilter.filterName !==
        this.props.selectedFilter.filterName)
    ) {
      if (
        nextProps.selectedFilter.filterJson &&
        nextProps.selectedFilter.filterJson.GroupBy &&
        typeof nextProps.selectedFilter.filterJson.GroupBy !== 'undefined'
      ) {
        if (nextProps.selectedFilter.filterJson.DatesBy !== 'Custom Date') {
          this.setState({
            showStartEndDate: false
          });
        } else {
          this.setState({
            showStartEndDate: true
          });
        }
        if (
          nextProps.selectedFilter.filterJson.startDate === '' ||
          nextProps.selectedFilter.filterJson.endDate === '' ||
          nextProps.selectedFilter.filterJson.timezone === '' ||
          nextProps.selectedFilter.filterJson.timezone === null
        ) {
          console.log(this.dayBeforeTimeStamp);
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: this.dayBeforeTimeStamp,
            endDate: this.currentTimestamp,
            GroupBy: nextProps.selectedFilter.filterJson.GroupBy,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            selectedBreak: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: zone
          });
        } else {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: nextProps.selectedFilter.filterJson.startDate,
            endDate: nextProps.selectedFilter.filterJson.endDate,
            GroupBy: nextProps.selectedFilter.filterJson.GroupBy,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            selectedBreak: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: nextProps.selectedFilter.filterJson.timezone || zone
          });
        }
        console.log(this.state.GroupBy);
      } else {
        if (nextProps.selectedFilter.filterJson.DatesBy !== 'Custom Date') {
          this.setState({
            showStartEndDate: false
          });
        } else {
          this.setState({
            showStartEndDate: true
          });
        }
        if (
          nextProps.selectedFilter.filterJson.startDate === '' ||
          nextProps.selectedFilter.filterJson.endDate === '' ||
          nextProps.selectedFilter.filterJson.timezone === '' ||
          nextProps.selectedFilter.filterJson.timezone === null
        ) {
          let zone = commonManager.getTimeZone();
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: this.dayBeforeTimeStamp,
            endDate: this.currentTimestamp,
            freeTextSearch: nextProps.selectedFilter.filterJson.freeTextSearch,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            selectedBreak: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: zone
          });
        } else {
          this.setState({
            _id: nextProps.selectedFilter._id,
            startDate: nextProps.selectedFilter.filterJson.startDate,
            endDate: nextProps.selectedFilter.filterJson.endDate,
            freeTextSearch: nextProps.selectedFilter.filterJson.freeTextSearch,
            selectedCampaign: nextProps.selectedFilter.filterJson.projects,
            selectedBreak: nextProps.selectedFilter.filterJson.projects,
            filterNameUpdate: nextProps.selectedFilter.filterName,
            DatesBy: nextProps.selectedFilter.filterJson.DatesBy,
            timezone: nextProps.selectedFilter.filterJson.timezone || zone
          });
        }
      }
    }
  }

  handleProjectSearch(value) {
    searchCompany(value, CampaignList => this.setState({ CampaignList }));
  }

  handleBreakSearch(value) {
    searchCompany(value, BreakList => this.setState({ BreakList }));
  }
  handleStickyAgentSearch(value) {
    searchCompany(value, StickyAgentList => this.setState({ StickyAgentList }));
  }

  handleDesposeSearch(value) {
    searchCompany(value, DesposeList => this.setState({ DesposeList }));
  }

  handleTeamSearch(value) {
    searchCompany(value, TeamList => this.setState({ TeamList }));
  }

  handleUserSearch(value) {
    searchCompany(value, UserList => this.setState({ UserList }));
  }

  onFilterByDate(type, date) {
    if (this.state.isChange) {
      const formatDate = date ? moment(date).format('YYYY-MM-DD HH:mm') : null;
    }
  }



  getCampaign() {
    var that = this;
    this.mAPI.sendGetAPI(
      `campaign?limit=100&page_no=1`,
      data => {
        // console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ CampaignList: data.data });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        let message = data && data.message ? data.message : "Something went Wrong";
        Alert.error(message);
      }
    );
  }

  getBreak() {
    var that = this;
    this.mAPI.sendGetAPI(
      `setting/break?limit=100&page_no=1`,
      data => {
        // console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ BreakList: data.data });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        let message = data && data.message ? data.message : "Something went Wrong";
        Alert.error(message);
      }
    );
  }

  getStickyAgent() {
    var that = this;
    this.mAPI.sendGetAPI(
      `sticky-group/list?limit=100&page_no=1`,
      data => {
        // console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ StickyAgentList: data.data });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        let message = data && data.message ? data.message : "Something went Wrong";
        Alert.error(message);
      }
    );
  }

  getDespose() {
    var that = this;
    this.mAPI.sendGetAPI(
      `despose?limit=100&page_no=1`,
      data => {
        // console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ DesposeList: data.data });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  getUser() {
    var that = this;
    this.mAPI.sendGetAPI(
      `user?limit=100&page_no=1`,
      data => {
        // console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ UserList: data.data });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }


  getTeam() {
    var that = this;
    this.mAPI.sendGetAPI(
      `team/list?limit=100&page_no=1&filterValue=true&filterVariableValueType=boolean`,
      data => {
        // console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({ TeamList: data.data });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          Alert.error(`${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }



  onClick = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
      this.setState({ isLoading: true })
    }
    let tData = Object.assign({}, this.state);
    // if (tData.selectedCampaign && tData.selectedCampaign.length < 1) {
    //   // tData.selectedCampaign = this.generateProjectParams(tData.projects) ;
    //   tData.selectedCampaign = tData.projects;
    // }
    this.props.getData(tData);

  };

  generateProjectParams(tData) {
    return tData.map(data => ({
      value: data._id,
      label: data.name || ''
    }));
  }

  renderTimezones() {
    const { __ } = this.context;
    var that = this;
    return (
      <FlexItem>
        <ControlLabel>TIMEZONE</ControlLabel>
        <Select
          placeholder={'Search'}
          clearable={false}
          onChange={selectedOption => {
            if (selectedOption && selectedOption !== null) {
              this.setState({
                timezone: selectedOption,
              })
            }
          }}
          value={this.state.timezone}
          options={timezones}
        />
      </FlexItem>
    );
  }

  renderCampaign() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Campaign</ControlLabel>
        <Select
          placeholder={'Search'}
          onFocus={() => this.handleProjectSearch('')}
          onInputChange={this.handleProjectSearch}
          onChange={selectedOption => {
            this.setState({
              selectedCampaign: selectedOption
            });
          }}
          value={this.state.selectedCampaign}
          options={this.generateProjectParams(this.state.CampaignList)}
          multi
        />
      </FlexItem>
    );
  }

  renderBreak() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Break</ControlLabel>
        <Select
          placeholder={'Search'}
          onFocus={() => this.handleBreakSearch('')}
          onInputChange={this.handleBreakSearch}
          onChange={selectedOption => {
            this.setState({
              selectedBreak: selectedOption
            });
          }}
          value={this.state.selectedBreak}
          options={this.generateProjectParams(this.state.BreakList)}
          multi
        />
      </FlexItem>
    );
  }

  renderStickyAgent() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Users</ControlLabel>
        <Select
          placeholder={'Search'}
          onFocus={() => this.handleStickyAgentSearch('')}
          onInputChange={this.handleStickyAgentSearch}
          onChange={selectedOption => {
            this.setState({
              selectedStickyAgent: selectedOption
            });
          }}
          value={this.state.selectedStickyAgent}
          options={this.generateProjectParams(this.state.StickyAgentList)}
          multi
        />
      </FlexItem>
    );
  }
  renderDespose() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Tags</ControlLabel>
        <Select
          placeholder={'Search'}
          onFocus={() => this.handleDesposeSearch('')}
          onInputChange={this.handleDesposeSearch}
          onChange={selectedOption => {
            this.setState({
              selectedDespose: selectedOption
            });
          }}
          value={this.state.selectedDespose}
          options={this.generateProjectParams(this.state.DesposeList)}
          multi
        />
      </FlexItem>
    );
  }
  renderTeam() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>Team</ControlLabel>
        <Select
          placeholder={'Search'}
          onFocus={() => this.handleTeamSearch('')}
          onInputChange={this.handleTeamSearch}
          onChange={selectedOption => {
            this.setState({
              selectedTeam: selectedOption
            });
          }}
          value={this.state.selectedTeam}
          options={this.generateProjectParams(this.state.TeamList)}
          multi
        />
      </FlexItem>
    );
  }
  // renderTeam() {
  //   const { __ } = this.context;
  //   return (
  //     <FlexItem>
  //       <ControlLabel>Team</ControlLabel>
  //       <SelectFilterAPI
  //         dataUrl="team/list"
  //         selected={this.state.TeamList}
  //         label={"Team"}
  //         name={"Team 2"}
  //         multi={true}
  //         onSelect={(data)=>{
  //           console.log("data --", data);
  //         }}
  //       />
  //     </FlexItem>
  //   );
  // }

  renderUser() {
    const { __ } = this.context;
    return (
      <FlexItem>
        <ControlLabel>User</ControlLabel>
        <Select
          placeholder={'Search'}
          onFocus={() => this.handleUserSearch('')}
          onInputChange={this.handleUserSearch}
          onChange={selectedOption => {
            this.setState({
              selectedUser: selectedOption
            });
          }}
          value={this.state.selectedUser}
          options={this.generateProjectParams(this.state.UserList)}
          multi
        />
      </FlexItem>
    );
  }

  renderFormGroup(label, props) {
    return (
      <FlexItem>
        <ItemSearch>
          <ControlLabel>{label}</ControlLabel>
          <FormControl
            type="text"
            // placeholder={__('Type to search')}
            // onChange={e =>
            //   this.setState({ freeTextSearch: e.target.value })
            // }
            // value={this.state.freeTextSearch}
            {...props}
          />
        </ItemSearch>
      </FlexItem>
    );
  }

  handleChange(event) {
    this.setState({ filterName: event.currentTarget.value });
  }

  generateEntitysParams(supportedEntityList) {
    return supportedEntityList.map(entity => ({
      value: entity,
      label: entity
    }));
  }
  renderFrom() {
    return (
      <FlexItem>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('DID Number', {
              defaultValue: '',
              placeholder: '',
              id: 'from',
              value: this.state.fromSelector,
              onChange: e => {
                this.setState({ fromSelector: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
      </FlexItem>
    );
  }
  renderTo() {
    return (
      <FlexItem>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('CUSTOMER NUMBER', {
              defaultValue: '',
              id: 'to',
              value: this.state.toSelector,
              onChange: e => {
                this.setState({ toSelector: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>
      </FlexItem>
    );
  }

  resetAllData() {
    let tData = Object.assign({}, this.setState({
      startDate: '',
      endDate: '',
      freeTextSearch: '',
      fromSelector: '',
      toSelector: '',
      DatesBy: '',
      selectedUser: '',
      selectedBreak: '',
      selectedCampaign: '',
      selectedTeam: '',
      selectedColumns: '',
      selectedDespose: ''
    }));
    // this.setState({
    //   startDate: '',
    //   endDate: '',
    //   freeTextSearch: '',
    //   fromSelector: '',
    //   toSelector: ''
    // });

    console.log('tData', tData);
    this.props.getData(tData);
  }
  checkField(field) {
    const { filterList = [] } = this.props;
    return filterList && filterList.indexOf(field) > -1 ? true : false;
  }
  render() {
    const { __ } = this.context;
    const props = {
      inputProps: { placeholder: 'Click to select a date' },
      timeFormat: 'HH:mm',
      dateFormat: 'YYYY/MM/DD'
    };
    let zone = commonManager.getTimeZone();
    // const importeditTrigger = (
    //   <Button
    //     btnStyle="default"
    //     icon="add"
    //     size="small"
    //     style={{ marginLeft: '10px', marginRight: '10px' }}
    //   >
    //     Save Filter
    //   </Button>
    // );

    return (
      <InsightFilter>
        <form onSubmit={e => this.onClick(e)}>
          {/* <InsightTitle>{this.props.showButton()}</InsightTitle> */}
          <FlexRow>
            {this.checkField("renderTo") && this.renderTo()}
            {this.checkField("renderFrom") && this.renderFrom()}
            {this.checkField("renderUser") && this.renderUser()}
            {this.checkField("renderBreak") && this.renderBreak()}
            {this.checkField("renderTeam") && this.renderTeam()}
            {this.checkField("renderDespose") && this.renderDespose()}
            {this.checkField("renderMissedReason") && this.renderStickyAgent()}
            {this.checkField("renderStickyAgent") && this.renderStickyAgent()}
            {/* {this.renderCampaign()} */}
            {/* {this.renderProjects()} */}
            {/* {this.renderBreak()} */}
            {/* {this.renderUser()} */}
            {this.checkField("renderTimezones") && this.renderTimezones()}
            {(this.state.toshowGroupby !== 4 ||
              (this.state.GroupBy === 'Call Date' &&
                this.state.toshowGroupby === 4)) && (
                <FlexItem>
                  <ControlLabel>Select By Date</ControlLabel>
                  <Select
                    key={`${uuid.v4()}entity`}
                    value={this.state.DatesBy}
                    defaultValue={'Date'}
                    placeholder={'Select Dates'}
                    options={this.generateEntitysParams([
                      'Today',
                      'Last 24 Hrs',
                      'Yesterday',
                      'Last 7 Days',
                      'Custom Date'
                    ])}
                    onChange={items => {
                      let selected = '';

                      if (
                        items &&
                        typeof items !== 'undefined' &&
                        window.localStorage
                      ) {
                        selected = items.value;
                        let zone = commonManager.getTimeZone();

                        if (!selected) {
                          this.setState({
                            showStartEndDate: false,
                            startDate: "",
                            endDate: "",
                            sendStartTime:'',
                            sendEndTime:'',
                            DatesBy: null,
                          });
                          return;
                        }
                        const { startDate, endDate } = commonManager.calculateTimeRange(selected, zone);

                        this.setState({
                          startDate,
                          endDate,
                          DatesBy: selected
                        })

                      } else {
                        let dateObj =
                          parseInt(
                            moment()
                              .subtract(30, 'days')
                              .startOf('day')
                              .tz(zone.value)
                              .format('X')
                          ) * 1000;
                        let date =
                          parseInt(
                            moment()
                              .endOf('day')
                              .tz(zone.value)
                              .format('X')
                          ) * 1000;
                        this.setState({
                          startDate: dateObj,
                          endDate: date
                        });
                      }
                      this.setState({
                        DatesBy: selected
                        //showStartEndDate: false
                      });
                    }}
                  />
                </FlexItem>
              )}
            {(this.state.toshowGroupby == 2 ||
              (this.state.GroupBy !== 'Call Date' &&
                this.state.toshowGroupby == 4)) && (
                <FlexItem>
                  <ControlLabel>Select date</ControlLabel>
                  <Datetime
                    {...props}
                    value={this.state.startDate}
                    onBlur={this.onFilterByDate.bind(this, 'startDate')}
                    onChange={date => {
                      this.setState({
                        startDate:
                          parseInt(
                            moment(date)
                              .tz(zone.value)
                              .format('X')
                          ) * 1000
                      });
                    }}
                  />
                </FlexItem>
              )}
            {this.state.showStartEndDate && this.state.toshowGroupby !== 2 && (
              <FlexItem>
                <ControlLabel>Start date</ControlLabel>
                <Datetime
                  {...props}
                  value={this.state.startDate}
                  onBlur={this.onFilterByDate.bind(this, 'startDate')}
                  onChange={date => {
                    this.setState({
                      startDate:
                        parseInt(
                          moment(date)
                            .tz(zone.value)
                            .format('X')
                        ) * 1000
                    });
                  }}
                />
              </FlexItem>
            )}
            {this.state.toshowGroupby !== 2 && this.state.showStartEndDate && (
              <FlexItem>
                <ControlLabel>End date</ControlLabel>
                <Datetime
                  {...props}
                  value={this.state.endDate}
                  onBlur={this.onFilterByDate.bind(this, 'endDate')}
                  onChange={date => {
                    this.setState({
                      endDate:
                        parseInt(
                          moment(date)
                            .tz(zone.value)
                            .format('X')
                        ) * 1000
                    });
                  }}
                />
              </FlexItem>
            )}
            {/* {(this.state.toshowGroupby === 0 ||
            this.state.toshowGroupby === 1 ||
            this.state.toshowGroupby === 4) && (
              <FlexItem>
                <FormWrapper>
                  <FormColumn>
                    {this.renderFormGroup('Free Text Search', {
                      defaultValue: '',
                      placeholder: '',
                      required: true,
                      id: 'freeTextSearch',
                      value: this.state.freeTextSearch,
                      onChange: e => {
                        this.setState({ freeTextSearch: e.target.value });
                      }
                    })}
                  </FormColumn>
                </FormWrapper>
              </FlexItem>
            )} */}
            {(this.state.toshowGroupby === 1 ||
              this.state.toshowGroupby === 4) && (
                <FlexItem>
                  <ControlLabel>Group By</ControlLabel>
                  <Select
                    key={`${uuid.v4()}entity`}
                    value={this.state.GroupBy}
                    defaultValue={'Call Date'}
                    placeholder={'Select to GroupBy'}
                    options={this.generateEntitysParams([
                      'Call Date',
                      'InterMedia',
                      'Promo Code',
                      'Radial Error',
                      'DNIS',
                      'Creative Code'
                    ])}
                    onChange={items => {
                      let selected = '';
                      if (items && typeof items !== 'undefined') {
                        selected = items.value;
                      }
                      if (selected !== 'Call Date') {
                        let mStartDate =
                          parseInt(
                            moment()
                              .startOf('day')
                              .tz(zone.value)
                              .format('X')
                          ) * 1000;
                        let date =
                          parseInt(
                            moment()
                              .endOf('day')
                              .tz(zone.value)
                              .format('X')
                          ) * 1000;
                        let mStartTimeStamp = mStartDate;
                        let mEndTimeStamp = date;
                        this.setState({
                          startDate: mStartTimeStamp,
                          endDate: mEndTimeStamp,
                          showStartEndDate: false,
                          GroupBy: selected
                        });
                      } else {
                        this.setState({
                          GroupBy: selected
                        });
                      }
                      console.log(this.state.GroupBy);
                    }}
                  />
                </FlexItem>
              )}
          </FlexRow>
          <br />
          <FlexRow style={{ textAlign: 'end' }}>
            <FlexItem>
              <Button
                btnStyle="default"
                icon="filter"
                type="submit"
                // onClick={this.onClick}
                size="small"
              >
                {this.state.isLoading ? (
                  <Spinner style={{ height: '2px', width: '2px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
                ) : (
                  'Filter'
                )}

              </Button>

              <Button
                btnStyle="simple"
                icon="refresh"
                onClick={this.resetAllData}
                size="small"
                style={{ marginLeft: '10px' }}
              >
                Reset
              </Button>
            </FlexItem>
          </FlexRow>
        </form>
      </InsightFilter>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// src/modules/screens/reporting/Filter.js